import { ShopifyPlan } from "@redotech/redo-model/integration/shopify/shopify-plan";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getShopifyPlan = {
  name: "getShopifyPlan" as const,
  input: z.null(),
  output: z.object({
    plan: createEnum([
      ShopifyPlan.NONE,
      ShopifyPlan.STANDARD,
      ShopifyPlan.PLUS,
    ]),
  }),
};
